import _ from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import useTableNavigation from '../../../../ui/tables/useTableNavigation';

import { ApplicableTableSettings, codesPortCodeList } from '../../../../tableSettings';

import {
  NumberedIndicatorRenderer,
  TextAlignLeftRenderer,
} from '../../../../uiControls/SmartTableRenderers';

import SmartTable from '../../../../uiControls/SmartTable';

import useFastStorage, { useTypedFastStorage } from '../../../../hooks/useFastStorage';
import useFunction from '../../../../hooks/useFunction';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';

import ApplicationContext from '../../../../ApplicationContext';
import SecondaryButton from '../../../../ui/SecondaryButton';
import CyLocationLookupField from '../../../../uiControls/lookup/CyLocationLookupField';
import { Search, initialSearch, isFilterObjectEmpty } from '../../../../filtering';
import { JobNames } from '../../../../framework.core/JobNames';
import { CodeScheduleDKListItem } from '../../../../fms.data/models/CodeScheduleDKListItem';
import { ApiResult, InsertResult } from '../../../../framework.core/data/ApiResult';
import { SQLType } from '../../../../framework.core/data/SQLInfo';
import { CheckLookup } from '../../../../fms.data/lookup/CheckLookup';
import { TextValue } from '../../../../framework.core/data/TextValue';
import InlineInputControlRow from '../../../../ui/layout/InlineInputControlRow';
import TextBox from '../../../../ui/TextBox';
import IfmsModal from '../../../../ui/IfmsModal';
import useGlobalYesNoDialog from '../../../../hooks/useGlobalYesNoDialog';
import { FmsSecTask } from '../../../../fms.core/constants';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import { sortingListData } from '../../ReferenceFiles';
import { findSecurityTask } from '../../../../util';
import useFilterBar from '../../../../hooks/useFilterBar';
import { ListOrderBy } from "../../../common/AbstractListView";
import postal from 'postal';
import BlackInverseButton from '../../../../ui/BlackInverseButton';
import constants from '../../../../constants';
import IFmsReferenceFilesContext from '../../IfmsReferenceFilesContext';
import { Portal } from 'react-portal';
import CloseButton from '../../../../ui/CloseButton';

function SdpDetails({
  readonly,
  sdp,
  onChange
}:{
  readonly: boolean,
  sdp: CodeScheduleDKListItem,
  onChange: (change: Partial<CodeScheduleDKListItem>) => void
}) {
  return (
    <div>
      <div style={{display: 'flex'}}>
        <div style={{width: '320px'}}>
          <InlineInputControlRow label="Schedule D&K Code" mode="smaller-2x">
            <div style={{width: '100px'}}>
              <TextBox name='scheduledk-code' disabled={readonly} maxLength = {10} value={sdp.code} onChange={e => onChange({code: e.target.value})} />
            </div>
          </InlineInputControlRow>

          <InlineInputControlRow label="Port Name" mode="smaller-2x">
            <TextBox name='scheduledk-portname' disabled={readonly} maxLength = {50} value={sdp.portName} onChange={e => onChange({portName: e.target.value})} />
          </InlineInputControlRow>
        </div>

        <div style={{marginLeft: '40px', width: '320px'}}>
          <InlineInputControlRow label="CY Location" mode="smaller-2x">
            <CyLocationLookupField
              maxLength={50}
              disabled={readonly}
              name='scheduledk-cy'
              lookupId="ifms-sdk-cy"
              initialValue={sdp.cyName ?? ''}
              onTextChange={cyName => onChange({
                cy: 0,
                cyName: cyName ?? '',
              })}
              onSelect={cyLocation => {
                onChange({
                  cy: cyLocation.id,
                  cyName: cyLocation.shortName ?? '',
                })
              }}
            />
          </InlineInputControlRow>

          <InlineInputControlRow label="CFS Location" mode="smaller-2x">
            <CyLocationLookupField
              maxLength={50}
              disabled={readonly}
              name='scheduledk-cfs'
              lookupId="ifms-sdk-cfs"
              initialValue={sdp.cfsName ?? ''}
              onTextChange={cyName => onChange({
                cfs: 0,
                cfsName: cyName ?? '',
              })}
              onSelect={cyLocation => {
                onChange({
                  cfs: cyLocation.id,
                  cfsName: cyLocation.shortName ?? '',
                })
              }}
            />
          </InlineInputControlRow>

        </div>
      </div>
    </div>
  );
}

// let inlineElement:ISchDkPort = {};

// function ActionRenderer({ data, row }:any) {
//   return (
//     <div style={{textAlign: 'left', marginLeft: '10px'}}>
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Cancel"
//         
//         onClick={() => data[row.index].isNew ? data[row.index].onDelete() : data[row.index].requestOperationCancel()}
//       >
//         <FontAwesomeIcon icon={faTimes} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Save"
//         
//         onClick={() => data[row.index].onSave()}
//       >
//         <FontAwesomeIcon icon={faSave} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       {!data[row.index].isNew &&
//         <>
//           <PrimaryInverseButton
//             disabled={data[row.index].editIndex !== row.index}
//             style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//             data-tooltip="Delete"
//             
//             onClick={() => data[row.index].onDelete()}
//           >
//             <FontAwesomeIcon icon={faTrashAlt} />
//           </PrimaryInverseButton>
//         </>
//       }
//     </div>
//   );
// }

// function CodeRenderer({data, row, cell}:any) {
//   useEffect(() => {
//     const focusElement = document.getElementById('ifms-sdk-name') as HTMLInputElement;
//     if (focusElement) {
//       focusElement.focus();
//       focusElement.select();
//     }
//   },
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     []
//   );

//   if (data[row.index].editIndex !== row.index) {
//     return <TextAlignLeftRenderer cell={cell} />;
//   } else {
//     return (
//       <div style={{marginTop: '0px'}}>
//         <TextBoxUncontrolled id="ifms-sdk-name" initialValue={inlineElement.code} onChange={(e:React.ChangeEvent<HTMLInputElement>) => {
//           inlineElement.code = e.target.value;
//           data[row.index].setHasChanges(true);
//           }} />
//       </div>
//     );
//   }
// }


// function PortNameRenderer({data, row, cell}:any) {
//   if (data[row.index].editIndex !== row.index) {
//     return <TextAlignLeftRenderer cell={cell} />;
//   } else {
//     return (
//       <div style={{marginTop: '0px'}}>
//         <TextBoxUncontrolled id="ifms-sdk-portname" initialValue={inlineElement.portName} onChange={(e:React.ChangeEvent<HTMLInputElement>) => {
//           inlineElement.portName = e.target.value;
//           data[row.index].setHasChanges(true);
//           }} />
//       </div>
//     );
//   }
// }


// function CyRenderer({data, row, cell}:any) {
//   if (data[row.index].editIndex !== row.index) {
//     return <TextAlignLeftRenderer cell={cell} />;
//   } else {
//     return (
//       <div style={{marginTop: '0px'}}>
//         <CyLocationLookupField
//           lookupId="ifms-sdk-cy"
//           initialValue={inlineElement.cyName ?? ''}
//           onTextChange={cyName => {
//             inlineElement.cy = 0;
//             inlineElement.cyName = cyName ?? '';
//           }}
//           onSelect={cyLocation => {
//             if(inlineElement.cy !== cyLocation.id) {
//               data[row.index].setHasChanges(true);
//             }
//             inlineElement.cy = cyLocation.id;
//             inlineElement.cyName = cyLocation.shortName ?? '';
//           }}
//         />
//       </div>
//     );
//   }
// }

// function CfsRenderer({data, row, cell}:any) {
//   if (data[row.index].editIndex !== row.index) {
//     return <TextAlignLeftRenderer cell={cell} />;
//   } else {
//     return (
//       <div style={{marginTop: '0px'}}>
//         <CyLocationLookupField
//           lookupId="ifms-sdk-cfs"
//           initialValue={inlineElement.cfsName ?? ''}
//           onTextChange={cyName => {
//             inlineElement.cfs = 0;
//             inlineElement.cfsName = cyName ?? '';
//           }}
//           onSelect={cfsLocation => {
//             if(inlineElement.cfs !== cfsLocation.id) {
//               data[row.index].setHasChanges(true);
//             }
//             inlineElement.cfs = cfsLocation.id;
//             inlineElement.cfsName = cfsLocation.shortName ?? '';
//           }}
//         />
//       </div>
//     );
//   }
// }

function formatElement(data:any) {
  return data;
}

function formatData(data: Array<any>) {
  return data.map(d => formatElement(d));
}

function ScheduleDkPort({
  componentIndex
}: {
  componentIndex: number
}) {
  useFunction({invokers: {
    ifmsReferenceFilesSave: save,
    ifmsReferenceFilesCancel: cancelOperation,
  }});
  useFunctionKeys({onEsc: cancelOperation});
  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const {selectTableRow, tableNavigationCleanup } = useTableNavigation('codes-sdk-list', onRowSelect, onRowDoubleSelect, ['code'], false, false, false);

  const tableRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [data, _setData, removeData, dataRef] = useFastStorage(`ifms-referenceFiles-sdk-list`, []);
  const [sdp, _setSdp, removeSdpFromStorage] = useTypedFastStorage<CodeScheduleDKListItem>(`ifms-referenceFiles-sdk-editable`, null);
  const [orderBy, setOrderBy] = useFastStorage(`ifms-referenceFiles-sdk-orderby`, {
    orderBy: 'code',
    orderByAscending: true,
    //general1: 'Code',
    //pageSize: systemSettings.defaultPageSize,
  });
  const listSec = findSecurityTask(appContext, FmsSecTask.CodeOceanPort);
  const [selectedRow, setSelectedRow] = useState(-1);
  const tableHeight = 520;
  const listItemType = 'CodeScheduleDKListItem';

  //////////////////////////////////////////////////

  const { FilterButton, search } = useFilterBar(
    codesPortCodeList,
    undefined,
    getDefaultOrderBy,
    String(componentIndex),
    undefined,
  );

  function getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'code',
      orderByAscending: true,
    };
  }

  ///////////////////////////////////////////////////


  function setSdp(c:any) {
    setHasChanges(true);
    _setSdp(c);
  }

  function setData(d:Array<any>) {
    removeData();
    _setData(d);
  }

  async function fetchData(api:any, search:Search) {
    setLoading(true);
    //<pt220819: portal
    // const apiResult = await api.getCodesOceanPortCodes(search);
    // setData(formatData(apiResult && apiResult.data ? apiResult.data : []));
    const apiResult = await api.getListItems(JobNames.OceanPort,
      listItemType,
      CodeScheduleDKListItem.calculateSearchParameters(search),
      1, search.pageSize);
    //pt220819>

    const fetchedTableData  = formatData(apiResult && apiResult.entities ? apiResult.entities : []);
    sortingListData(CodeScheduleDKListItem, fetchedTableData , setData, orderBy);
    setLoading(false);
    setHasChanges(false);
  }

  useEffect(() => {
    if (isFilterObjectEmpty(search) && search.version === 1) reload(false);
    
    return () => {
      removeData();
      tableNavigationCleanup();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (loading || (isFilterObjectEmpty(search) && search.version === 1)) {
      return;
    }
    fetchData(appContext.api, search);
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search]
  );

  useEffect(() => {
    if (dataRef.current?.length > 0 && !loading) {
      selectTableRow(0, true);
      onRowSelect(0);
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading]
  );

  // async function reload(generalText:string = '') {
  //   setOrderBy({
  //     orderBy: 'code',
  //     orderByAscending: true,
  //     generalText1: generalText,
  //     pageSize: systemSettings.defaultPageSize,
  //   })

  //   await fetchData(appContext.api, orderBy);
  // }

  async function reload(clearAll:boolean = true) {
    const searchValue = clearAll ? initialSearch : search;
    await fetchData(appContext.api, searchValue);
  }

  function onHeaderClick(header:any) {
    if (header && header.id !== 'indicator') {
      if (header.id === orderBy.orderBy) {
        setOrderBy({orderByAscending: !orderBy.orderByAscending });
      } else {
        setOrderBy({orderBy: header.id, orderByAscending: true});
      }
    }
    sortingListData(CodeScheduleDKListItem, data, setData, orderBy);
  }

  function onRowDoubleSelect(rowIndex:number) {
    if (!dataRef || !dataRef.current) {
      return;
    }
    if (rowIndex >= 0 && rowIndex < dataRef.current.length && _.isEmpty(sdp)) {
      const objContainer = { ...dataRef.current[rowIndex], edit: true, view: true, editIndex: rowIndex};
      setSdp(objContainer);
    }
  }

  function onRowSelect(rowIndex:number) {
    setSelectedRow(!isNaN(rowIndex) ? rowIndex : -1 );
  }

  function selectForNew() {
   // clearTableSelection();
    
    const newCodeModel = new CodeScheduleDKListItem();   
    setSdp(newCodeModel);
    
    setSdp({
      edit : false,
      view: false,
      isNew: true,
      code: '',
      portName: '',
      id: 0,
      cy: 0,
      cyName: '',
      cfs: 0,
      cfsName: '',
    });
  }

  function selectForEdit(){
    if (selectedRow >= 0 && selectedRow < dataRef.current.length && _.isEmpty(sdp)) {
      const objContainer = { ...dataRef.current[selectedRow], edit: true, view: false, editIndex: selectedRow};
      setSdp(objContainer);
    
    }
  }

  function selectForView(){
    if (selectedRow >= 0 && selectedRow < dataRef.current.length && _.isEmpty(sdp)) {
      const objContainer = { ...dataRef.current[selectedRow], edit: true, view: true, editIndex: selectedRow};
      setSdp(objContainer);
    }
  }

  async function selectForDelete(){
    const doConfirm = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    , false, 0, true, 'warning');
    if(doConfirm){
      const apiResult = await appContext.api.deleteJobDetail(JobNames.OceanPort, { id:dataRef.current[selectedRow].id , pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        await reload(false);
      } else
        showGlobalOkDialog(<p>{"Cannot delete"}</p>);
    } else
      return;
  }

  async function deleteEntity() {
    if (!sdp) {
      return;
    }

    const doDelete = await showGlobalYesNoDialog(<p>Are you sure you want to delete?</p>, false, 0, true, 'warning');
    if (!doDelete) {
      return;
    }

    //<pt220819: portal
    // const apiResult = await appContext.api.deleteCodesOceanPortCode(data[ei].id);
    // if (!apiResult) {
    //   return;
    // }
    const apiResult:ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType,
      SQLType.Delete, _.omit(sdp, ['isNew']));
    if(!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.SAVE_ERROR_MESSAGE}</p>);
      return;
    }
    //pt220819>

    cancelOperation();
    await reload(false);
  }

  function cancelOperation() {
    const filterNode = document.getElementById('ifms-list-screen-filter');
    const channel = postal.channel('ifms-filter');

    if (!filterNode) {
      setHasChanges(false);
      removeSdpFromStorage();
    } else {
      channel.publish('ifms-filter.dismiss');
    }
    return true;
  }

  async function checkDataAsync(): Promise<boolean>{
    if(!sdp) return false;

    if(sdp.code?.length === 0){
      await showGlobalOkDialog(<p>{"  * Empty Code"}</p>);
      return false;
    }
    else {
      //if(inlineElement.isNew || checkPropDirty(inlineElement as TrackableEntity, 'code')){
      if(sdp.isNew || hasChanges ){
        if (await appContext.api.checkupDuplicateFieldValueIsDuplicate("T_CODEOCEANPORT", "F_Code", sdp.code, 'F_Id', sdp.id)) {
          await showGlobalOkDialog(<p> * Duplicate Number in [Code]</p>);
          return false;
        }
      }
    }

    const comLks: CheckLookup[] = [];

    comLks.push(new CheckLookup({
      labelName: "CY Location",
      textValue: new TextValue({Text: sdp.cyName, IntValue: sdp.cy})
    }))
    comLks.push(new CheckLookup({
      labelName: "CFS Location",
      textValue: new TextValue({Text: sdp.cfsName, IntValue: sdp.cfs})
    }))

    const tempErrMsg = await appContext.api.checkCompanyLookupField(comLks);
    if (tempErrMsg) {
      await showGlobalOkDialog(tempErrMsg);
      return false;
    }

    return true;
  }

  async function save() {
    if (!sdp) {
      return;
    }

    if (!sdp.isNew && !hasChanges) {
      cancelOperation();
      return;
    }

    if (!await checkDataAsync()) return;

    //<pt220819: portal
    // const apiResult = inlineElement.isNew
    //   ? await appContext.api.saveCodesOceanPortCode(_.omit(inlineElement, ['isNew']))
    //   : await appContext.api.editCodesOceanPortCode(_.omit(inlineElement, ['isNew']));
    
    // if (!apiResult || !apiResult.success) {
    //   return;
    // }

    // data[ei] = formatElement(apiResult.data);
    const apiResult:ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType,
      sdp.isNew ? SQLType.Insert : SQLType.Update,
      _.omit(sdp, ['isNew']));
    if(!apiResult || !apiResult.success) {
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.SAVE_ERROR_MESSAGE}</p>);
      return;
    }

    // data[ei] = formatElement(inlineElement);
    // if(apiResult.result) {
    //   data[ei].id = apiResult.result.newId;
    // }

    await showGlobalOkDialog(<p>The data has been saved</p>);

    cancelOperation();
    await reload(false);
  }

  const tableOptions:ApplicableTableSettings = {
    customTableId: 'codes-sdk-list',
    ref: tableRef,
    selectable: true,
    tableName: 'sdktypeList',
    ...codesPortCodeList,
    height: `${tableHeight}px`,
    // data: data.map((x:any, i:number) => ({...x, indicator: (i + 1).toString(), editIndex: ei, onDelete: deleteEntity, onSave: save, onCancel: cancelOperation, setHasChanges})),
    data: (data ?? []).map((x:any) => ({...x})),
    rowRenderers: [
      { accessor: 'indicator', Cell: NumberedIndicatorRenderer },
      { accessor: 'code', Cell: TextAlignLeftRenderer },
      { accessor: 'portName', Cell: TextAlignLeftRenderer },
      { accessor: 'cyName', Cell: TextAlignLeftRenderer },
      { accessor: 'cfsName', Cell: TextAlignLeftRenderer },
    ],
    orderBy: [orderBy],
    onHeaderClick,
  };

  //const newEnabled = sdp === null;
  const hasSelectedRow = !isNaN(selectedRow) && !(selectedRow < 0);
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;

  return (
    <div style={{ marginTop:'40px'}}>
      {/* <Portal node={document && document.getElementById('settings-placeholder')}>
        <h1>Ocean <FontAwesomeIcon icon={faAngleRight} />&nbsp;Schedule D&K Port</h1>
        <div style={{width: '320px', fontWeight: 'bold'}}>
          
        </div>
      </Portal> */}


      {/* <div style={{ width: '320px', fontSize: '11px', fontWeight: 'bold' }}>
        <ClearableSearch
          initialValue={orderBy?.generalText1 || ''}
          onSearch={async generalText1 => {
            await reload(generalText1 === null ? '' : generalText1);
          }}
        />
      </div> */}

      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', marginTop:'5px'}}>
          <div className="ifms-common-bar-element" style={{marginLeft:'66px'}}>
            <CloseButton name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
        </div>
      </Portal>

      <div style={{display:'flex', width: '862px'}}>
        <div style={{marginLeft: 'auto'}}></div>
        <div style={{position: 'relative', top: '-4px' }}>
          <div style={{ display: 'none' }}>
            <FilterButton /> &nbsp;&nbsp;
          </div>
          <SecondaryButton name='codes-scheduledk-add-button' size="regular" disabled={!canBeAdd} onClick={selectForNew}>New</SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton name='codes-scheduledk-view-button' size="regular" disabled={!hasSelectedRow} onClick={selectForView}>View</SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton name='codes-scheduledk-edit-button' size="regular" disabled={!canBeEdit} onClick={selectForEdit}>Edit</SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton name='codes-scheduledk-delete-button' size="regular" disabled={!canBeDeleted} onClick={selectForDelete}>Delete</SecondaryButton>&nbsp;
          <BlackInverseButton name='list-screen-refresh' size="large"  disabled={loading} onClick={() => {cancelOperation(); reload(false); }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton>
        </div>  
      </div>

      <div style={{width: '862px'}}>
        <SmartTable {...tableOptions} />
      </div>
      <IfmsModal
        width="760px"
        isBlueHeader
        isOpen={!!sdp}
        title={sdp && sdp.edit ? (sdp.view ? 'Schedule D&K View' : 'Schedule D&K Edit') : 'Schedule D&K New'}
        onCancel={cancelOperation}
      >
        {!!sdp &&
          <div className="report-popup">
            <SdpDetails readonly={sdp.view || !canBeEdit} sdp={sdp} onChange={setSdp} />
            <div className='report-footer'>
              {canBeEdit  && !sdp.view &&
                  <SecondaryButton
                    name='scheduledk-detail-save-button' 
                    size="regular"
                    style={{width: '90px'}}
                    onClick={save}
                  >
                    SAVE
                  </SecondaryButton>
              }
              {canBeEdit  && sdp.view &&
                  <SecondaryButton
                    name='scheduledk-detail-edit-button'
                    size="regular"
                    style={{width: '90px'}}
                    onClick={()=>setSdp({edit:true, view:false})}
                  >
                    Edit
                  </SecondaryButton>
              }
              
              {!sdp.isNew && !sdp.view && listSec?.grantDel &&
                <SecondaryButton
                  name='scheduledk-detail-delete-button'
                  size="regular"
                  style={{width: '90px'}}
                  onClick={deleteEntity}
                >
                  DELETE
                </SecondaryButton>
              }
              <SecondaryButton
                name='scheduledk-detail-close-button'
                size="regular"
                style={{width: '90px'}}
                onClick={cancelOperation}>
                CANCEL
              </SecondaryButton>
            </div>
          </div>
        }
      </IfmsModal>
    </div>
  );
}

export default ScheduleDkPort;
